module.exports = __webpack_public_path__ + "assets/img/Type E (69).060167f1.jpg";